import { EnrolledStudents } from 'pages/corporate_reports/EnrolledStudents';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'corporate_reports/enrolled_students',
  route: 'enrolled_students',
  label: 'Alunos Inscritos',
  parentName: 'corporate_reports',
  list: EnrolledStudents,
  actions: ['list', 'export']
};

export default generateResources(resource);
